import { render, staticRenderFns } from "./ContentFieldDemo.vue?vue&type=template&id=396bcf99"
import script from "./ContentFieldDemo.vue?vue&type=script&lang=js"
export * from "./ContentFieldDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports